import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import dayjs from "dayjs";
import PrimaryButton from "./primaryButton";
import SecondaryButton from "./secondaryButton";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { handleDecodeJSON, handleEncodeJson } from "../utils/encodeDecodeJson";
import feedbackActions from "../Redux/feedback/actions";
import { useDispatch, useSelector } from "react-redux";
import useFetchCandidateTokenDetails from "../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../utils/auditLog";

export default function ThankYou() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { heartBeat } = useSelector((state) => state.examReducer);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  
  let candidateData = JSON.parse(sessionStorage.getItem("candidate_details"));
  let isFeedback = candidateTokenDetails?.configuration?.feedback;
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 700,
        lg: 1200,
        xl: 1536,
      },
    },
  });
  const data = [
    {
      title: "Center Name",
      val: `: ${candidateTokenDetails?.configuration?.venueName}`,
    },
    {
      title: "Candidate Name",
      val: `:  ${candidateTokenDetails?.user?.candidateName}`,
    },
    {
      title: "Roll No",
      val: `:  ${candidateData?.rollNo}`,
    },
    {
      title: "Exam Date",
      val: `:  ${dayjs(candidateData?.startTime).format("DD MMM, YYYY")}`,
    },
  ];

  const handleFeedback = async () => {
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Feedback Review",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    const formData = {
      imageSize: "L",
      language: "english",
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: feedbackActions.GET_FEEDBACK_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  const handleExit = async () => {
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Exit",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    Cookies.remove("test_engine_token");
    sessionStorage.removeItem("candidate_exam_details");
    localStorage.removeItem("updatedQuestionsList");
    sessionStorage.removeItem("examEnded");
    sessionStorage.removeItem("lastUpdatedIndex");
    sessionStorage.removeItem("isEarlyMovedSection");
    navigate(`/${Cookies.get("test_engine_project")}/login`);
  };

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              p: 3,
              pb: 6,
              bgcolor: "#fff",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                color: "rgba(63, 65, 209, 1)",
                fontSize: "28px",
                pt: 3,
                pb: 3,
              }}
            >
              Thank You for submitting the exam
            </Typography>
            {data?.map((v, i) => (
              <Grid
                container
                key={i}
                p={2}
                sx={{ border: "1px solid rgba(30, 30, 30, 0.1)" }}
              >
                <>
                  <Grid
                    item
                    md={5}
                    style={{
                      fontSize: "22px",
                      fontWeight: "bold",
                      lineHeight: "22px",
                      textAlign: "start",
                    }}
                  >
                    {v?.title}
                  </Grid>
                  <Grid
                    item
                    md={7}
                    style={{
                      fontSize: "16px",
                      lineHeight: "17px",
                      textAlign: "start",
                    }}
                  >
                    {v?.val}
                  </Grid>
                </>
              </Grid>
            ))}
            <Grid container pt={2} spacing={3}>
              <Grid item md={isFeedback ? 6 : 12}>
                <SecondaryButton width={"100%"} onClick={handleExit}>
                  Exit
                </SecondaryButton>
              </Grid>
              {isFeedback && (
                <Grid item md={6}>
                  <PrimaryButton
                    width={"100%"}
                    color={"#000"}
                    borderRadius={"138px"}
                    onClick={handleFeedback}
                  >
                    continue to feedback
                  </PrimaryButton>
                </Grid>
              )}
            </Grid>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
